<ng-container *transloco="let convert;">
  @if (variant === 'static') {
    <h2 class="text-uppercase fw-bold h5 pb-4">{{convert('sellModule.details.equipmentAccessories.optionsAndAccessories')}}</h2>
  }
  <app-options-accessories [optionAccessories]="translatedData" [longDescriptions] = "longDescriptions$ | async" [options]="options$ | async" [variant]="variant" [limit]="maxEquipRows"></app-options-accessories>
</ng-container>
